import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/downlineProfile";
import { formatDateLong, formatMonthDay } from "../../../../common/util/formatDate";
import { storedLocale } from "../../../Authentication/util";
import IconBirthdayCake from "../../../../common/icons/IconBirthdayCake/IconBirthdayCake";
import { KeyDatesLabelKey } from "../../shared/types";

interface KeyInformationKeyDatesRowProps {
  label?: KeyDatesLabelKey;
  value?: string;
}
const KeyInformationKeyDatesRow = ({ label, value }: KeyInformationKeyDatesRowProps) => {
  const { t } = useTranslation(["downlineProfile"]);
  const date = label === "birthday" ? formatMonthDay(value, storedLocale()) : formatDateLong(value, storedLocale());
  return (
    <>
      <div className="key-dates-row">
        <span>
          {label && t(`keyInformation.keyDatesLabels.${label}`, defaultContent.keyInformation.keyDatesLabels[label])}
          {label === "birthday" && <IconBirthdayCake />}
        </span>
        <span aria-label={date === "--" ? "Not available" : ""}>{date}</span>
      </div>
    </>
  );
};

export default KeyInformationKeyDatesRow;
